export default "__VITE_ASSET__CDa6hR7U__"